import * as types from '../types.js';
import obs_load_warehouses_create_outputs from '../types/obs_load_warehouses_create_outputs.js';

export default {

	html: `
		<style>
			#create-derrubada.form {
				width: min(32rem, calc(100vw - 1.5rem));
				max-width: 32rem;
				box-sizing: border-box;
			}
			#create-derrubada .hint { font-size: 0.85rem; color: #444; margin: 0.35rem 0 0.75rem; }
			#create-derrubada #company_id,
			#create-derrubada #warehouse_id { width: 100%; max-width: 100%; box-sizing: border-box; }
		</style>
		<form id="create-derrubada" class="form" autocomplete="off">
			<div class="title">Gerar derrubada</div>
			<p class="hint">Gera a onda com os <strong><span id="cd-count">0</span></strong> pedido(s) marcados: saídas com reserva e tarefas do empilhador. Pedido já com saída não entra.</p>
			<div class="mtl fsb">
				<label title="Empresa dos pedidos marcados">Empresa
					<select id="company_id" required></select>
				</label>
			</div>
			<div class="fsb">
				<label title="Só escolha se houver mais de um armazém físico">Armazém físico
					<select id="warehouse_id">
						<option value="">— Picking na empresa (não precisa escolher) —</option>
					</select>
				</label>
			</div>
			<div class="ckb">
				<label><input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir estoque expirado</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" type="button">Cancelar</button>
				<button class="bn_Enter button" type="submit">Gerar derrubada</button>
			</div>
		</form>
	`,

	form:
	{
		selector: '#create-derrubada',
		init(formset)
		{
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub()] },
		{
			properties: { selector: '#warehouse_id' },
			types: [
				types.pubsub(),
				types.observer('company_id'),
				obs_load_warehouses_create_outputs(),
			],
		},
		{ properties: { selector: '#include_expired' }, types: [types.checkbox()] },
	],
};
